import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from 'src/app/_services/user.service';
import { MessageService } from 'primeng/api';
import { ClinicService } from 'src/app/_services/clinic.service';
import { confirmPasswordValidator } from 'src/app/validators/confirm-password.validator';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-create-nurse',
  templateUrl: './create-nurse.component.html',
  styleUrls: ['./create-nurse.component.scss'],
})
export class CreateNurseComponent implements OnInit {
  loading: boolean = false;
  submitted: boolean = false;
  roles: any[] = [];
  userRole: any;

  sancQualifications = [
    {
      label: 'OHC',
      value: 'OHC',
    },
    {
      label: 'PHC',
      value: 'PHC',
    },
    {
      label: 'RN',
      value: 'RN',
    },
    {
      label: 'RM',
      value: 'RM',
    },
    {
      label: 'ADV Midwife',
      value: 'ADV Midwife',
    },
    {
      label: 'COM',
      value: 'COM',
    },
    {
      label: 'OHNP',
      value: 'OHNP',
    },
    {
      label: 'Ed et ADM',
      value: 'Ed et ADM',
    },
    {
      label: 'ADM',
      value: 'ADM',
    },
    {
      label: 'PSYC',
      value: 'PSYC',
    },
    {
      label: 'NA',
      value: 'NA',
    },
    {
      label: 'OPTH',
      value: 'OPTH',
    },
    {
      label: 'CCRN',
      value: 'CCRN',
    },
  ];

  userForm = this.fb.group(
    {
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      username: ['', Validators.required],
      role_id: ['', Validators.required],
      enabled: [true],
      password: ['', Validators.required],
      confirm_password: ['', Validators.required],
    },
    { validators: confirmPasswordValidator }
  );

  nurseDetailForm = this.fb.group({
    contact_number: ['', Validators.required],
    alternate_contact_number: [''],
    sanc_qualification: [''],
    sanc_number: ['', Validators.required],
    practice_number: ['', Validators.required],
  });

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private messageService: MessageService,
    private clinicService: ClinicService,
    private ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    this.userService.getRoles().subscribe((roles: any) => {
      this.roles = roles;
      console.log('Roles:', this.roles);

      // set role id where role_name is clinic_admin
      const clinicAdminRole = this.roles.find(
        (role) => role.name === 'clinic-admin'
      );
      if (clinicAdminRole) {
        console.log('Clinic Admin Role:', clinicAdminRole);
        this.userRole = clinicAdminRole.id;
        this.userForm.patchValue({ role_id: this.userRole });
      }
    });
  }

  get f() {
    return this.userForm.controls;
  }

  closeDialog() {
    this.ref.close();
  }

  onSubmit() {
    this.submitted = true;

    if (this.userForm.invalid) {
      return;
    }

    this.loading = true;

    // transform userForm to match API requirements
    const userData = {
      ...this.nurseDetailForm.value,
      user: {
        ...this.userForm.value,
        role_id: this.userRole, // ensure role_id is set correctly
      },
    };

    console.log('Submitting User Data:', userData);

    this.clinicService.createNurse(userData).subscribe(
      (response) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Nurse created successfully',
          key: 'nurseCreate',
        });
        this.loading = false;
        this.ref.close(response);
      },
      (error) => {
        const errorMsg =
          error?.error?.detail ||
          'Error creating nurse, please check that the username or email is not already in use.';
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: errorMsg,
          key: 'nurseCreate',
        });
        this.loading = false;
      }
    );
  }
}
